// extracted by mini-css-extract-plugin
module.exports = {"homeIcon":"HomeIcon_homeIcon__1w0m-"};